<template>
  <div>
    <LanguageSelector/>
    <Alert :text="$t('profile_module_success_message')" type="success" v-if="success" dismissable="true"/>
    <Alert :text="$t('profile_module_error_message')" type="danger" v-if="error" dismissable="true"/>
    <Alert :text="$t('profile_module_mail_error_message')" type="success" v-if="changePasswordMessage == true"
           dismissable="true"/>
    <Alert :text="$t('profile_module_recovery_mail_error_message')" type="danger"
           v-if="changePasswordMessage == 'email error'" dismissable="true"/>
    <div class="content-body" style="padding-bottom: 150px;">
      <!-- users edit start -->
      <section class="users-edit">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <ul class="nav nav-tabs mb-2" role="tablist" v-if="verified">
                <li class="mb-1">
                  <button class="btn btn-primary" @click="changePasswordModal">
                    {{ $t('profile_module_change_password_button') }}
                  </button>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active fade show" id="account" aria-labelledby="account-tab" role="tabpanel">
                  <!-- users edit account form start -->
                  <form novalidate>
                    <div class="row">
                      <div class="col-12 col-sm-6">
                        <div class="form-group">
                          <div class="controls">
                            <label>{{ $t('profile_module_label_name') }}</label>
                            <input type="text" class="form-control" :placeholder="$t('profile_module_placeholder_name')"
                                   v-model="name">
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="controls">
                            <label>{{ $t('profile_module_label_mail') }}</label>
                            <input type="text" class="form-control" :placeholder="$t('profile_module_placeholder_mail')"
                                   v-model="email" disabled>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="controls">
                            <label>{{ $t('profile_module_label_language') }}</label>
                            <input type="text" class="form-control"
                                   :placeholder="$t('profile_module_placeholder_language')" v-model="language" disabled>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6">
                        <div class="form-group">
                          <label>{{ $t('profile_module_label_role') }}</label>
                          <select class="form-control" disabled>
                            <option selected>{{ type.charAt(0).toUpperCase() + type.slice(1) }}</option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label>{{ $t('profile_module_label_position_in_organisation') }}</label>
                          <input type="text" class="form-control"
                                 :placeholder="$t('profile_module_placeholder_position_in_organisation')"
                                 v-model="position">
                        </div>
                        <div class="form-group" v-if="this.$store.state.currentUser.user.phoneNumber">
                          <label>{{ $t('profile_module_label_phone_number') }}</label>
                          <input type="text" class="form-control"
                                 :placeholder="$t('profile_module_placeholder_phone_number')" v-model="phoneNumber"
                                 disabled>
                        </div>
                        <div class="form-group" v-else>
                          <label>{{ $t('profile_module_label_phone_number') }}</label>
                          <input type="tel" id="phoneNumber" class="form-control" v-model="phoneNumberTarget">
                        </div>
                      </div>
                      <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                        <button type="button" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                @click="updateAdminData()">
                          {{ $t('profile_module_save_changes_button') }}
                        </button>
                      </div>
                    </div>
                  </form>
                  <!-- users edit account form ends -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- users edit ends -->
      <!--      change password modal-->
      <div class="modal fade text-left" id="change-password-modal" tabindex="-1" role="dialog"
           aria-labelledby="create-modal-title" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content resetPasswordPopup">
            <div class="modal-header">
              <h3 class="modal-title resetPasswordHeading" id="create-modal-title">{{
                  $t('profile_module_change_password_popup_heading')
                }}</h3>
              <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close"
                      @click="dialogueClose()">
                <img :src="closeImage" alt="Close image"/>
              </button>
            </div>
            <div class="modal-body">
              <Alert :text="$t('profile_module_change_password_popup_required_error')" type="danger" dismissable="false"
                     v-if="requiredError"/>
              <Alert :text="resetPasswordErrorText" type="danger" dismissable="false"
                     v-if="resetPasswordErrorText != ''"/>
              <Alert :text="$t('user_edit_module_reset_password_popup_compare_password_error')" type="danger"
                     dismbissable="false" v-if="comparePasswordError"/>
              <Alert :text="$t('profile_module_change_password_popup_password_error')" type="danger"
                     dismbissable="false" v-if="requiredPasswordError"/>
              <form>
                <div class="form-group row">
                  <div class="col-md-12 col-sm-12">
                    <input type="password" name="password" class="form-control inputHeight"
                           :placeholder="$t('profile_module_change_password_popup_new_password_placeholder')"
                           v-model="modalPassword" @keyup="passwordCheck"/>

                  </div>
                </div>
                <p class="passwordTitle">({{
                    $t('profile_module_change_password_popup_new_password_validation_error')
                  }})
                </p>
                <div class="form-group row">
                  <div class="col-md-12 col-sm-12">
                    <input type="password" class="form-control inputHeight"
                           :placeholder="$t('profile_module_change_password_popup_placeholder_reenter_password')"
                           name="confirm_password" v-model="modalPasswordConfirm" @keyup="comparePassword"/>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer modalFooter">
              <button type="button" class="btn btn-light-secondary" data-dismiss="modal" aria-label="Close"
                      @click="dialogueClose">
                <em class="bx bx-x d-block d-sm-none"></em>
                <span class="d-none d-sm-block " style="color: white">{{
                    $t('profile_module_change_password_popup_cancel_button')
                  }}</span>
              </button>
              <button type="button" class="btn btn-primary ml-1" :disabled="!modalPassword" @click="submitPassword()">
                <em class="bx bx-check d-block d-sm-none"></em>
                <span class="d-none d-sm-block">{{ $t('profile_module_change_password_popup_submit_button') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--      change password confirmation modal-->
      <div class="modal fade text-left" id="reset-password-confirm-modal" tabindex="-1" role="dialog"
           aria-labelledby="create-modal-title" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content resetPasswordDialogue">
            <div class="modal-header">
              <h3 class="modal-title resetPasswordHeading" id="create-modal-title">{{
                  $t('profile_module_change_password_confirmation_popup_heading')
                }}</h3>
              <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
                <img :src="closeImage" alt="Close image"/>
              </button>
            </div>
            <div class="modal-body">

              <h3 class="modal-title resetPasswordSuccessHeading" id="create-modal-title">"{{
                  $t('profile_module_change_password_confirmation_popup_message')
                }}”</h3>
            </div>
            <div class="modal-footer modalFooter">

              <button type="button" class="btn btn-light-secondary" data-dismiss="modal" aria-label="Close">
                <em class="bx bx-x d-block d-sm-none"></em>
                <span class="d-none d-sm-block " style="color: white">{{
                    $t('profile_module_change_password_confirmation_popup_cancel_button')
                  }}</span>
              </button>
              <button type="button" class="btn btn-primary ml-1" data-dismiss="modal" aria-label="Close">
                <em class="bx bx-check d-block d-sm-none"></em>
                <span class="d-none d-sm-block">{{
                    $t('profile_module_change_password_confirmation_popup_ok_button` ')
                  }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade text-left" id="phone-verification-modal" tabindex="-1" role="dialog"
         aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">{{ $t('profile_module_label_verify_your_number') }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-x"></em>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <input maxlength="4" type="number" class="form-control" placeholder="0000" v-model="code">
            </div>
            <div class="text-center">
              <button type="button" class="btn btn-primary" @click="phoneVerification()">
                <em class="bx bx-check d-block d-sm-none"></em>
                <span class="d-none d-sm-block">{{ $t('profile_module_verify_button') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getLanguageName} from '@/app-assets/js/get-language.js'
import Alert from '@/components/Alerts'
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import {useVuelidate} from '@vuelidate/core'
import {sameAs, required} from '@vuelidate/validators'
import Swal from 'sweetalert';

export default {
  setup: () => ({v$: useVuelidate()}),
  data() {
    return {
      name: this.$store.state.currentUser.user.name,
      email: this.$store.state.currentUser.user.email,
      position: this.$store.state.currentUser.user.position,
      type: this.$store.state.currentUser.user.type,
      phoneNumber: this.$store.state.currentUser.user.phoneNumber,
      languageCode: this.$store.state.currentUser.user.language,
      success: false,
      error: false,
      changePasswordMessage: false,
      code: '',
      phoneNumberObj: null,
      phoneNumberTarget: '',
      requiredError: false,
      resetPasswordErrorText: "",
      comparePasswordError: false,
      requiredPasswordError: false,
      modalPassword: "",
      modalPasswordConfirm: "",
      emailData: "",
      userId: "",
      lang: "",
      verified: false,
      closeImage: require('@/assets/close.png').default,
    }
  },
  validations() {
    return {
      modalPassword: {required},
      modalPasswordConfirm: sameAs(this.modalPassword)
    }
  },

  components: {
    Alert
  },

  methods: {
    changePassword() {
      let self = this
      this.changePasswordError = false;
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait"
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent"
        }
      });
      this.$apiCall.post('/v1/auth/send/recover', {
        email: this.email,
        language: (this.languageCode == 'en' || this.languageCode == 'ar') ? this.languageCode : 'en'
      })
        .then(response => {
          $.unblockUI();
          this.handleSweetAlertPopup();
        })
        .catch(err => {
          $.unblockUI()
          if (err.response.status == 405) {
            this.changePasswordMessage = 'email error'
          }
        })
    },
    changePasswordModal() {
      this.resetPasswordErrorText = '';
      this.error = false;
      $("#change-password-modal").modal();
    },
    changePasswordResetModal() {
      $("#change-password-modal").modal('toggle');
      $("#reset-password-confirm-modal").modal();
    },

    handleSweetAlertPopup() {
      Swal({
        type: 'success',
        title: 'Check your email address for the reset link',
        showConfirmButton: false,
        timer: 2500,
        buttonsStyling: false,
      })
        .then(() => this.logout());
    },
    passwordCheck() {
      let self = this;
      let regularExpression = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{7,}$/;
      if (regularExpression.test(self.modalPassword)) {
        self.requiredPasswordError = false;
      } else {
        this.requiredPasswordError = true;
      }
    },
    dialogueClose() {
      let self = this;
      self.requiredError = false;
      self.resetPasswordErrorText = '';
      self.comparePasswordError = false;
      self.requiredPasswordError = false;
      self.modalPassword = '';
      self.modalPasswordConfirm = '';
    },
    comparePassword() {
      let self = this;
      if (self.modalPassword == self.modalPasswordConfirm) {
        self.comparePasswordError = false;
      } else {
        self.comparePasswordError = true;
      }
    },
    closePasswordModal() {
      let self = this;

    },

    phoneVerificationMessage() {
      let self = this
      if (!this.$store.state.currentUser.user.phoneNumber && this.phoneNumberTarget) {
        let countryData = this.phoneNumberObj.getSelectedCountryData()
        let pN = '%2B' + countryData.dialCode + this.phoneNumberTarget.replace(`+${countryData.dialCode}`, "")
        $("#phone-verification-modal").modal()
        self.$apiCall.put(`/v1/me/verify/phone?phoneNumber=${pN}`)
          .then(response => {
            $("#phone-verification-modal").modal()
          })
      }
    },
    submitPassword() {
      let self = this;
      self.resetPasswordErrorText = ''
      if (self.modalPasswordConfirm) {
        self.requiredError = false
      } else {
        self.requiredError = true
      }
      if (self.modalPasswordConfirm != self.modalPassword) {
        self.comparePasswordError = true
      } else {
        self.comparePasswordError = false
      }
      if (!self.requiredError && !self.comparePasswordError && !self.requiredPasswordError) {
        console.log("api-call-password-change")
        self.$apiCall
          .patch(`v1/admins/reset/password/${this.userId}`, {
            email: self.emailData,
            newPassword: self.modalPassword,
            language: self.lang
          })
          .then(function (response) {
            self.changePasswordResetModal()
            location.href = "/logout";
          })
          .catch(function (error) {
            self.resetPasswordErrorText =
              `<strong>Ops!</strong> ${error.response.data.message}`;
            self.modalPassword = "";
            self.modalPasswordConfirm = "";
          });
      }
    },

    phoneVerification() {
      let self = this
      let countryData = this.phoneNumberObj.getSelectedCountryData()
      let pN = '+' + countryData.dialCode + this.phoneNumberTarget.replace(`+${countryData.dialCode}`, "")

      var block_ele = $("#phone-verification-modal .modal-content");
      $(block_ele).block({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait"
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent"
        }
      });

      this.$apiCall.post('/v1/me/verify/phone', {
        "phoneNumber": pN,
        "verificationCode": parseInt(self.code)
      })
        .then(response => {
          $(block_ele).unblock();
          self.$store.dispatch('currentUser/editProfile', response.data)
          $("#phone-verification-modal").modal('hide')
        })
    },

    updateAdminData() {
      let self = this
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait"
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent"
        }
      });
      this.$apiCall.patch('/v1/me/admin', {
        "name": self.name,
        "position": self.position,
      })
        .then(response => {
          $.unblockUI();
          self.$store.dispatch('currentUser/editProfile', response.data)
          self.success = true
          self.phoneVerificationMessage()
        })
        .catch(error => {
          $.unblockUI();
          self.error = true
        })
    },

    initTelInput() {
      let input = document.querySelector("#phoneNumber")
      this.phoneNumberObj = intlTelInput(input)
    },

    logout() {
      location.href = '/logout'
    },
  },

  watch: {
    phoneNumberTarget: function (value) {
      this.phoneNumberTarget = value.replace(/[^\d|\-+]/g, '')
    }
  },

  computed: {
    language() {
      return getLanguageName(this.$store.state.currentUser.user.language)
    },

    docusignAuth() {
      return localStorage.getItem('dTok')
    }
  },
  mounted() {
    this.emailData = this.$store.state.currentUser.user.email
    this.userId = this.$store.state.currentUser.user.id
    this.lang = this.$store.state.currentUser.user.language
    this.verified = this.$store.state.currentUser.user.emailVerified
    console.log("helloooo", this.emailData)

    if (!this.$store.state.currentUser.user.phoneNumber) {
      this.initTelInput()
    }
  }
}
</script>

<style scoped>
.resetPasswordHeading {
  color: #4A0A1E;
  font-size: 18px !important;
  font-weight: 450 !important;
}

.inputHeight {
  height: 3.5em;
}

.modalFooter {
  border-top: 1px solid #DFE3E7;
}

.resetPasswordSuccessHeading {
  color: #767676;
  font-size: 20px !important;
  font-weight: 400 !important;
  text-align: center;
  margin-top: 4%;
}

.resetPasswordDialogue {
  border-radius: 1rem !important;
  margin-top: 35%;
}

.resetPasswordPopup {
  border-radius: 1rem !important;
  margin-top: 10em;
  margin-left: 6em;
}

@media (min-width: 768px) and (max-width: 1280px) {
  .resetPasswordPopup {
    height: 28em;
    border-radius: 1rem !important;
    margin-top: 10em;
    margin-left: 6em;
  }

  .resetPasswordDialogue {
    height: 19em;
    border-radius: 1rem !important;
    margin-top: 13em;
    margin-left: 6em;
  }

}

.passwordTitle {
  white-space: nowrap;
  font-size: 14px;
}
</style>
